import * as yup from 'yup'
import { IOdometerFormValues } from 'features/Vehicles/types'

export const schema = (): yup.SchemaOf<IOdometerFormValues> => {
  const validations = {
    odometerReading: yup.number().nullable()
  }

  return yup.object().shape(validations)
}
